import { Paragraph, TextRun } from "docx";

const ParagraphPrint = async (data) => {
  //   const paragraphs = data
  //     .split("\n")
  //     .map(
  //       (line) => new Paragraph({ children: [new TextRun(line)], style: "arial" })
  //     );

  const paragraphs = new Paragraph({
    style: "arial",
    // children: [new TextRun(data)],
    children: data?.text?.split("\n").flatMap((line, index, arr) => {
      const runs = [
        new TextRun({
          text: line,
          color: data?.textSetting?.title ? "e41e26" : "000000",
          size: data?.textSetting?.title ? 22 : 20,
          font: "Arial",
        }),
      ];
      if (index < arr.length - 1) {
        runs.push(new TextRun({ break: 1 }));
      }
      return runs;
    }),
  });
  return paragraphs;
};

export default ParagraphPrint;

// docChildren.push(ParagraphPrint(item.text));
